import {
	Align,
	Delay,
	EventDispatcher,
	Execute,
	I18NextProvider,
	IAssetHandle,
	Layout,
	ParallelChain,
	PlaySpine,
	SequenceChain,
	SpineAnimation,
	SpineResource,
	Sprite,
	Text,
	TextureResource,
	ViewColumns,
	ViewFixedSize,
	asset,
	inject,
	subscription,
	view,
} from "@spawn/core";

import { Subscription } from "rxjs";
import Victor from "victor";
import { GameEvents, SetMultiplierEvent, TextStyles } from "@spawn/nrg-games-core";

@view
export class MultiplerNotchView extends ViewFixedSize {
	@inject private readonly eventDispatcher!: EventDispatcher;
	@inject private readonly i18n!: I18NextProvider;

	@asset(TextureResource) public readonly notchTexture!: IAssetHandle<TextureResource>;
	@asset(SpineResource) public readonly multiplierSpine!: IAssetHandle<SpineResource>;

	@subscription subscriptions: Subscription[] = [];

	private containerView!: ViewColumns;
	private winsText!: Text;
	private multiplierText!: Text;
	private multiplierAnimation!: SpineAnimation;

	constructor() {
		super({ size: new Victor(640, 132) });

		this.addBackground();
		this.addContainerView();
		this.addWinsText();
		this.addMultiplier();

		this.subscriptions.push(
			this.eventDispatcher
				.event$<SetMultiplierEvent>(GameEvents.SetMultiplier)
				.subscribe((event) => this.setMultiplier(event.payload.multiplier))
		);
	}

	public addBackground(): void {
		const bg = new Sprite(this.notchTexture());
		bg.layout = new Layout(Align.CenterHorizontal, Align.CenterVertical);
		this.addChild(bg);
	}

	public addContainerView(): void {
		this.containerView = new ViewColumns({ numberOfCells: 2, size: new Victor(330, 54) });
		this.containerView.layout = new Layout(Align.CenterHorizontal, Align.CenterVertical);
		this.containerView.layout.offset = new Victor(-3, -12); // "centers" it over the bg asset

		this.addChild(this.containerView);
	}

	public addWinsText(): void {
		this.winsText = TextStyles.default(this.i18n.t("general.allWins"), {
			fontSize: 23,
		});
		this.winsText.layout = new Layout(Align.CenterHorizontal, Align.CenterVertical);
		this.winsText.position = new Victor(30, 0);
		this.containerView.getCell(0).addChild(this.winsText);
	}

	public addMultiplier(): void {
		this.multiplierText = TextStyles.gold("0x", {
			fontSize: 42,
		});
		this.multiplierText.layout = new Layout(Align.CenterHorizontal, Align.CenterVertical);
		this.containerView.getCell(1).addChild(this.multiplierText);

		this.multiplierAnimation = new SpineAnimation(this.multiplierSpine());
		this.multiplierAnimation.visible = false;
		this.multiplierAnimation.skinName = "default";
		this.multiplierAnimation.position = new Victor(-953, -165); // offset the spine's "natural" position :)
		this.containerView.getCell(1).addChild(this.multiplierAnimation);
	}

	private setMultiplier(multiplier: number): void {
		this.multiplierAnimation.visible = true;

		void new ParallelChain(
			new PlaySpine(this.multiplierAnimation, "multiplier_bar_increase"),
			new SequenceChain(
				new Delay(0.5),
				new Execute(() => {
					this.multiplierText.text = `${multiplier}x`;
				})
			)
		).play();
	}
}
